import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import { StyleProps as CheckboxStyleProps } from "@insite/mobius/Checkbox/Checkbox";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    headerProps: {
        css: css`
            button[aria-expanded^="false"] {
                margin-top: 4px;
                border: 0px;
                background: #f0f4f3;
                border-radius: 4px;
            }
            button[aria-expanded^="true"] {
                margin-top: 4px;
                border: 0px;
                background: #f0f4f3;
                border-radius: 4px 4px 0px 0px;
            }
        `,
    },
    panelProps: {
        css: css`
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 350px;
            background: #f0f4f3;
            border: 0px;
            border-radius: 0px 0px 4px 4px;
            margin-bottom: 4px;
            padding: 0 15px 15px;
        `,
    },
};

productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        width: 100%;
        &:not(:last-child) {
            padding-bottom: 0px;
        }
    `,
};

productListFilterAccordionSectionStyles.checkBox = {
    css: css<CheckboxStyleProps>`
        align-items: flex-start;
        span[role="checkbox"] {
            background: #fff;
            ${({ _sizeVariant }) =>
                _sizeVariant === "small"
                    ? css`
                          margin-top: 5px;
                      `
                    : css`
                          margin-top: 0px;
                      `}
        }
    `,
    typographyProps: {
        css: css`
            word-break: break-all;
            font-size: 14px;
        `,
    },
};
productListFilterAccordionSectionStyles.checkBoxSelected = {
    css: css<CheckboxStyleProps>`
        align-items: flex-start;
        span[role="checkbox"] {
            ${({ _sizeVariant }) =>
                _sizeVariant === "small"
                    ? css`
                          margin-top: 5px;
                      `
                    : css`
                          margin-top: 0px;
                      `}
        }
    `,
    typographyProps: {
        css: css`
            word-break: break-all;
            font-size: 14px;
        `,
        weight: "bold",
    },
};
